import OrderSummaryTile from './OrderSummaryTile';
import connectContainer from './OrderSummaryTileContainer';

export default connectContainer(OrderSummaryTile);
